import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';
@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private url = 'email';
  constructor(private httpClient: HttpClientService) {}
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`/email.json`, params);
  }
  create(params: any = {}): Promise<any> {
    return this.httpClient.post(`/email.json`, params);
  }
}
